type KpiCardProps = {
  label: string
  value: number | string
  sub?: string
}

const KpiCard = ({ label, value, sub }: KpiCardProps): JSX.Element => (
  <div
    role="region"
    aria-label={label}
    className="flex flex-col gap-4 rounded-2xl bg-white p-8 shadow-[0_0_20px_5px_rgba(0,0,0,0.08)]"
  >
    <span className="text-xl font-medium text-stone-gray" aria-hidden="true">
      {label}
    </span>
    <div className="flex flex-col gap-1">
      {/* aria-label combines label + value so screen readers announce "Total users: 342" */}
      <span className="text-4xl font-bold text-dark-blue" aria-label={`${label}: ${value}`}>
        {value}
      </span>
      {sub && (
        <span className="text-xl text-stone-gray" aria-label={sub}>
          {sub}
        </span>
      )}
    </div>
  </div>
)

export const KpiCardSkeleton = (): JSX.Element => (
  <div
    aria-hidden="true"
    className="flex flex-col gap-4 rounded-2xl bg-white p-8 shadow-[0_0_20px_5px_rgba(0,0,0,0.08)]"
  >
    <div className="h-5 w-2/3 rounded bg-soft-gray animate-pulse" />
    <div className="h-9 w-1/2 rounded bg-soft-gray animate-pulse" />
  </div>
)

export default KpiCard
